<template>
  <div class="h-toolbarBg">
    <ejs-toolbar>
      <div>
        <div>
          <!--<button class="icon hero-icon hero-icon-import" :title="$t('SubscriberIms.import')" @click='buttonClk("import")'/>-->
          <button :title='$t("SubscriberIms.import")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("import")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-import e-icons"></span>
          </button>
        </div>
        <div>
          <!--<button class="icon hero-icon hero-icon-export" :title="$t('DataManagent.export')" @click='buttonClk("export")'/>-->
          <button :title='$t("SubscriberIms.export")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("export")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-export e-icons"></span>
          </button>
        </div>
        <div>
          <!--<button class="icon hero-icon hero-icon-remove" :title="$t('SubscriberIms.del')" @click='buttonClk("delete")'/>-->
          <button :title='$t("SubscriberIms.del")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("delete")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-remove e-icons"></span>
          </button>
        </div>
        <div>
          <!--<button class="icon hero-icon hero-icon-refresh" :title="$t('SubscriberIms.fresh')" @click='buttonClk("search")'/>-->
          <button :title='$t("SubscriberIms.fresh")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn" @click='buttonClk("search")' data-ripple="true" tabindex="-1" style="width: auto;">
            <span class="e-btn-icon icon hero-icon hero-icon-refresh e-icons"></span>
          </button>
        </div>
      </div>
    </ejs-toolbar>
  </div>
</template>

<script>

export default {
  name: 'DataTableMenu',
  data() {
    return {

    };
  },
  methods: {
    buttonClk(args) {
      this.$emit('methodEnum', args);
    },
  }
};
</script>

<style scoped>

</style>
